import React from 'react';
import { Grid, Paper, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { formatCurrency } from '../../../utils/formattingUtils';

const FeeSummary = ({ totalAssignedFee, totalPaidFee, pendingFee, lastPaidFee }) => {
  const theme = useTheme();

  const summaryCards = [
    {
      label: 'Assigned',
      value: formatCurrency(totalAssignedFee),
      helper: 'Configured fee amount',
      color: theme.palette.primary.main,
    },
    {
      label: 'Paid',
      value: formatCurrency(totalPaidFee),
      helper: 'Payments recorded',
      color: theme.palette.success.main,
    },
    {
      label: 'Pending',
      value: formatCurrency(pendingFee),
      helper: pendingFee > 0 ? 'Balance to collect' : 'No balance due',
      color: pendingFee > 0 ? theme.palette.warning.main : theme.palette.info.main,
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {summaryCards.map((card) => (
        <Grid item xs={12} md={4} key={card.label}>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              borderRadius: 1.5,
              height: '100%',
              background: `linear-gradient(180deg, ${card.color}12 0%, rgba(255,255,255,0.98) 100%)`,
            }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
              {card.label}
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 800, color: card.color, mt: 0.7 }}>
              {card.value}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.8 }}>
              {card.helper}
            </Typography>
          </Paper>
        </Grid>
      ))}

      {lastPaidFee ? (
        <Grid item xs={12}>
          <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent="space-between">
              <BoxLine label="Last Payment" value={formatCurrency(lastPaidFee.amount)} />
              <BoxLine label="Date" value={new Date(lastPaidFee.paymentDate).toLocaleDateString('en-GB')} />
              <BoxLine label="Mode" value={lastPaidFee.paymentMode || 'N/A'} />
              <BoxLine label="Reference" value={lastPaidFee.referenceNumber || 'N/A'} />
            </Stack>
          </Paper>
        </Grid>
      ) : null}
    </Grid>
  );
};

const BoxLine = ({ label, value }) => (
  <div>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 700, mt: 0.35 }}>
      {value}
    </Typography>
  </div>
);

export default FeeSummary;
